import { render } from "./mention_notification.vue?vue&type=template&id=83480c18"
import script from "./mention_notification.vue?vue&type=script&lang=js"
export * from "./mention_notification.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__